import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../../router/AppNavigation";

const ManagePaymentCampReminder = Loadable(
  lazy(() =>
    import("./ManagePaymentCampReminder").then(
      ({ ManagePaymentCampReminder }) => ({
        default: ManagePaymentCampReminder,
      }),
    ),
  ),
);

export const paymentReminderCampaignRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.payment.paymentReminder,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.PAYMENT_TRANSACTION]}>
        <ManagePaymentCampReminder />
      </AuthorizedRoute>
    ),
  },
];
